// src/components/admin/services/ServicesList.jsx
import { useState } from "react";
import { Edit2, Trash2, Loader2, AlertCircle } from "lucide-react";
import DeleteConfirmModal from "../DeletedModal";

const ServicesList = ({ services, loading, onDelete, onEdit }) => {
  const [deleteModal, setDeleteModal] = useState(false);
  const [selectedService, setSelectedService] = useState(null);

  const handleDeleteClick = (service) => {
    setSelectedService(service);
    setDeleteModal(true);
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center py-20">
        <Loader2 className="w-8 h-8 text-purple-600 animate-spin" />
      </div>
    );
  }

  if (!services || services.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-20 text-slate-400">
        <AlertCircle className="w-12 h-12 mb-3" />
        <p className="text-sm">هیچ خدمتی یافت نشد</p>
      </div>
    );
  }

  return (
    <>
      <div className="overflow-x-auto -mx-4 sm:mx-0">
        <div className="inline-block min-w-full align-middle">
          <table className="min-w-full divide-y divide-slate-200">
            <thead className="bg-slate-50">
              <tr>
                <th className="sm:block hidden px-3 sm:px-6 py-3 sm:py-4 text-right text-xs font-semibold text-slate-600 w-16 sm:w-20">
                  ردیف
                </th>
                <th className="px-3 pr-8 sm:!px-6 py-3 sm:py-4 text-right text-xs font-semibold text-slate-600">
                  نام خدمت
                </th>
                <th className="px-3 sm:px-6 py-3 sm:py-4 text-center text-xs font-semibold text-slate-600 w-24 sm:w-32">
                  عملیات
                </th>
              </tr>
            </thead>
            
            <tbody className="bg-white divide-y divide-slate-100">
              {services.map((service, index) => (
                <tr
                  key={service._id}
                  className="hover:bg-purple-50/30 transition-colors"
                >
                  <td className="sm:block hidden px-3 sm:px-6 py-3 sm:py-4 text-sm text-slate-600 whitespace-nowrap">
                    {index + 1}
                  </td>
                  
                  <td className="px-3 pr-8 sm:!px-6 py-3 sm:py-4">
                    <div className="flex items-center gap-2 sm:gap-3">
                      
                      { service?.images?.length >= 1 ? 
                        <div className="w-8 h-8 sm:w-10 sm:h-10 lg:w-16 lg:h-16 rounded-lg bg-gradient-to-br from-purple-500 to-purple-600 flex items-center justify-center text-white font-bold text-xs sm:text-sm shrink-0">
                          <img src={ (service?.images[0]?.includes('https://') || service?.images[0]?.includes('http://')) ? service?.images[0] : 'https://my-sarad-back.liara.run'+service?.images[0]} className="w-full h-full rounded-lg" alt="" />
                        </div>
                        :
                        <div className="w-8 h-8 sm:w-10 sm:h-10 lg:w-16 lg:h-16 rounded-lg bg-gradient-to-br from-purple-500 to-purple-600 flex items-center justify-center text-white font-bold text-xs sm:text-sm shrink-0">
                          {service.name?.charAt(0) || "؟"}
                        </div>
                      }
                      
                      <div className="min-w-0 flex-1">
                        <p className="text-xs sm:text-sm font-medium text-slate-800 mb-1">
                          {service.name}
                        </p>
                        
                        <div className="flex items-center gap-1.5 flex-wrap">
                          {service.kasht && (
                            <span className="text-[10px] sm:text-xs px-1.5 sm:px-2 py-0.5 bg-green-100 text-green-700 rounded whitespace-nowrap">
                              🌱 کاشت
                            </span>
                          )}
                          {service.retoosh && (
                            <span className="text-[10px] sm:text-xs px-1.5 sm:px-2 py-0.5 bg-blue-100 text-blue-700 rounded whitespace-nowrap">
                              ✨ روتوش
                            </span>
                          )}
                          {service.tarmim && (
                            <span className="text-[10px] sm:text-xs px-1.5 sm:px-2 py-0.5 bg-amber-100 text-amber-700 rounded whitespace-nowrap">
                              🔧 ترمیم
                            </span>
                          )}
                          {service.lift && (
                            <span className="text-[10px] sm:text-xs px-1.5 sm:px-2 py-0.5 bg-purple-100 text-purple-700 rounded whitespace-nowrap">
                              ⬆️ لیفت
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                  </td>
                  
                  <td className="px-3 sm:px-6 py-3 sm:py-4 whitespace-nowrap">
                    <div className="flex items-center justify-center gap-1 sm:gap-2">
                      <button
                        onClick={() => onEdit(service)}
                        className="p-1.5 sm:p-2 text-blue-600 hover:bg-blue-50 rounded-lg transition-colors"
                        title="ویرایش"
                      >
                        <Edit2 className="w-3.5 h-3.5 sm:w-4 sm:h-4" />
                      </button>
                      <button
                        onClick={() => handleDeleteClick(service)}
                        className="p-1.5 sm:p-2 text-red-600 hover:bg-red-50 rounded-lg transition-colors"
                        title="حذف"
                      >
                        <Trash2 className="w-3.5 h-3.5 sm:w-4 sm:h-4" />
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {deleteModal && selectedService && (
        <DeleteConfirmModal
          service={selectedService}
          onClose={() => {
            setDeleteModal(false);
            setSelectedService(null);
          }}
          onSuccess={() => {
            setDeleteModal(false);
            setSelectedService(null);
            onDelete();
          }}
        />
      )}
    </>
  );
};

export default ServicesList;